export const API_BASE_URL = 'https://19429ba06ff2.vps.myjino.ru/api';

export const COMMAND_ID = 'sergeyartsiomau-react-start-template';
